import React from 'react'
import "./portifolio.css";

import useFetch from "../hooks/useFetch";
import surveyimage from "./demo_image/surveyimage.png";
import tendermsimage from "./demo_image/tenderms.png";
import onlineexaminationimage from "./demo_image/onlineexamination.png";
import Slideshow from './slidshow';
// import { Element } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import { Survey,Tender,Exam,VimeoPlayer_survey,VimeoPlayer_exam } from './demopages/demo';
console.log(Survey,Tender,Exam,);
const data =[
    {

    id :1,
    image:surveyimage,
    title:'Online Survey System',
    github:'https://github.com/SWEG2012Batch-SecC-G8/Utopia_Survey',
    demo:Survey,
    live_demo: <VimeoPlayer_survey/>
    
},
{

    id :2,
    image:tendermsimage,
    title:'Tender Management Systetm',
    github:'https://github.com/mehari123/-Competitive-Programming',
    demo:Tender,
    live_demo:  <VimeoPlayer_survey/>

    },
{

    id :3,
    image:onlineexaminationimage,
    title:'Online Exam taking and creating app',
    github:'https://github.com/mehari123/School_examination',
    demo: Exam,
    live_demo: <VimeoPlayer_exam/>
},


]

// console.log(data)   
export const Portifolio = ()=>

        {
            return (
                <section id = 'portifolio'>

                    <h5>My Recent Work</h5>
                    <h2>Portifolio</h2>
                    <div className ="container portfolio_container">
                        {
                            data.map(({id,image,title,github,demo,live_demo})=>
                            {
                                return (
                                // console.log(id,image,title,github,demo);
                                    
                                    <article key={id} className="portfolio_item">
                                         
                                         <h2>{title}</h2>
                                        <Slideshow images={demo} interval={5000}  video ={live_demo} github={github}/>
                                       
                                        

                                    </article>
                                    
                                )
                                
                            })
                          
                        }
                </div>
                </section>
            )
        }


      
          
         

        



